
require("./../../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import SEO from 'global/SEO';
import { siteUrl } from 'constants/app';
import dynamic from 'next/dynamic';

const Fundachart = dynamic(() => import('features/pro-tools/Fundachart'));
const HomePageLayout = dynamic(() => import('global/HomePageLayout'));

function FundachartPage() {
  return (
    <HomePageLayout whiteFooterBackground>
      <SEO
        title="Stockbit - Fundachart Tools"
        description="Visualisasikan dan pelajari tren dari data fundamental perusahaan. Ketahui apakah saham yang kamu cari murah atau mahal. Pelajari tren harga berdasarkan indikator harga yang sesuai, seperti PBV Standard Deviation Band, PE Standard Deviation Band dan PE Price Band."
        url={`${siteUrl}/info/pro-tools/fundachart`}
      />
      <Fundachart />
    </HomePageLayout>
  );
}

export default FundachartPage;
